<template>
  <v-data-table
    :style="{ height }"
    height="calc(100% - 48px)"
    :headers="getHeaders()"
    :items="tableData"
    disable-pagination
    fixed-header
    :options.sync="sortOptions"
    calculate-widths
    hide-default-footer
    :server-items-length="1"
    disable-filtering
  >
    <template v-slot:top>
      <v-toolbar dense flat>
        <v-spacer></v-spacer>
        <v-menu offset-y left nudge-bottom="10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" title="Export" class="ml-1" v-bind="attrs" v-on="on">
              <v-icon>{{ icons.mdiDownload }}</v-icon></v-btn
            >
          </template>
          <v-list dense>
            <v-list-item @click="$emit('on-export', 'csv')">
              <v-list-item-title
                ><v-icon size="18" left>{{ icons.mdiFileExcel }}</v-icon> <span>CSV</span></v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="$emit('on-export', 'pdf')">
              <v-list-item-title
                ><v-icon size="18" left>{{ icons.mdiPdfBox }}</v-icon> <span>PDF</span></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn icon color="primary" @click="$emit('refreshed')">
          <v-icon>{{ icons.mdiRefresh }}</v-icon>
        </v-btn>
        <ChangeDetectionFilter
          :params="params"
          :options="options"
          :close-on-content-click="false"
          nudge-left="12"
          @change="$emit('on-search')"
          @on-reset="$emit('on-reset')"
        />
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn x-small icon color="primary" @click="viewInMap(item)">
        <v-icon title="View in map">{{ icons.mdiMap }}</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import dataTableMixin from '@/mixins/crud/data-table'
import { mdiFileExcel, mdiPdfBox, mdiMap, mdiFilterOutline } from '@mdi/js'
import ChangeDetectionFilter from '@/components/change-detection/ChangeDetectionFilter.vue'
import EventBus from '@/services/event-bus'
export default {
  components: { ChangeDetectionFilter },
  mixins: [dataTableMixin()],
  data() {
    return { icons: { mdiFileExcel, mdiPdfBox, mdiMap, mdiFilterOutline } }
  },
  computed: {
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: 'CDS', value: 'cdSet.name', sortable: false },
        { text: 'Ward', value: 'ward.name', sortable: false },
        { text: 'Plot No', value: 'plotNumber' },
        { text: 'Land Type', value: 'landType', sortable: false },
        { text: 'Change Type', value: 'cdClassType.name', sortable: false },
        { text: 'Area (m²)', value: 'area', align: 'right' },
        { text: 'Type', value: 'type' },
        { text: 'Status', value: 'cdStatus.name' },
        { text: 'View in map', value: 'actions', align: 'center', sortable: false },
      ]
    },
  },
  methods: {
    viewInMap(result) {
      const { id: resultId, cdSetId } = result
      this.$router.push({
        name: 'map-view',
        params: { tab: 0, resultId, cdSetId },
      })
      EventBus.$emit('view-result-in-map', resultId, cdSetId)
    },
  },
}
</script>
